import React from 'react';
import { withStyles } from '@material-ui/core';
import { getExceptionNumberLabel } from '../utils';

const styles = (theme) => ({
  label: {
    color: theme.TextColor,
    fontSize: theme.headerTextFontSize
  },
  value: {
    color: theme.TextColor,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600
  },
  valueHighlighted: {
    color: theme.HeaderSelectedText,
    fontWeight: 600
  },
  valueContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 8
  }
});

const ExceptionNumberDisplay = ({ classes, adeNumber, DispatchStore }) => {
  const exceptionNumberLabel = getExceptionNumberLabel(DispatchStore);
  if (!adeNumber) return null;

  return (
    <div className={classes.valueContainer}>
      <span className={classes.label}>{exceptionNumberLabel}</span>
      <span className={`${classes.value} ${classes.valueHighlighted}`}>{adeNumber}</span>
    </div>
  );
};

export default withStyles(styles)(ExceptionNumberDisplay);
